import './map.scss';
import { ajax, dispatch_event } from 'js/functions';
import { create_div, get_el } from 'js/utils';

import './popup.js';

let map
let Marker;

async function init() {

    const { Map } = await google.maps.importLibrary("maps");
    let { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    Marker = AdvancedMarkerElement;

    map = new Map(get_el('#interactive_map'), {
        center: { lat: 20, lng: -10 },
        zoom: 2.3,
        mapId: '15fb47365c5dd1c759736030', // placeholder, replace with client's
    });

    ajax('ff_get', { path: 'map/data'}, (data)=>{
        data.locations.forEach(init_location)
    })
}
init();

function init_location(location){

    const marker = new Marker({
        map,
        position: { lat: location.map.lat, lng: location.map.lng },
        content: get_custom_marker_html(),
    });

    marker.addListener('click', ()=>{
        dispatch_event('map/popup/open', {location})
    });
}

function get_custom_marker_html(){

    const div = create_div('map_marker');

    div.innerHTML = `<svg width="24" height="36" viewBox="0 0 24 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0.5C18.3555 0.5 23.4999 5.68527 23.5 12.0723C23.5 13.3349 22.947 14.9813 22.1338 16.7637C21.3121 18.5646 20.1909 20.5746 18.9893 22.5889C17.787 24.6042 16.4963 26.6366 15.334 28.4785C14.1682 30.3258 13.1356 31.9746 12.4375 33.2412L12 34.0361L11.5615 33.2412C10.8921 32.0252 9.87439 30.3845 8.71387 28.5254C7.55671 26.6717 6.26303 24.6082 5.05371 22.5635C3.84519 20.5201 2.71397 18.4834 1.88379 16.6807C1.06383 14.9 0.5 13.2711 0.5 12.0723C0.500103 5.68521 5.64674 0.5 12 0.5ZM12 7.20801C9.57294 7.20801 7.58603 9.2034 7.58594 11.6553C7.58594 14.1065 9.57283 16.1025 12 16.1025C14.4294 16.1025 16.417 14.1063 16.417 11.6553C16.4169 9.20354 14.4293 7.20801 12 7.20801Z" fill="white" stroke="#2EA9B0"/></svg>`;

    return div;
}